const companyInfo = require('../companyInfo')

module.exports = {
	companyInfo: companyInfo,

	images: [
		require('../../assets/media/pages/menu/page1.jpg'),
		require('../../assets/media/pages/menu/page2.jpg'),
	],
}